import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App'
// Google Analytics - Load before React app
;
(function () {
  const script1 = document.createElement('script');
  script1.async = true;
  script1.src = 'https://www.googletagmanager.com/gtag/js?id=G-PWK837LV5J';
  document.head.appendChild(script1);
  const script2 = document.createElement('script');
  script2.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', 'G-PWK837LV5J');
  `;
  document.head.appendChild(script2);
})();
render(<App data-id="element-122" />, document.getElementById('root'));